import {
  KevelAdBaseEntity,
  KevelAdBaseEntityParams,
} from "@shared/services/event_tracking/entities";

interface KevelShoppableUnitAdEntityParams extends KevelAdBaseEntityParams {
  forward_url: string;
}

export class KevelShoppableUnitAdEntity extends KevelAdBaseEntity {
  forward_url: string;

  constructor(params: KevelShoppableUnitAdEntityParams) {
    super(params);
    this.type = "kevel_shoppable_unit_ad";
    this.entity_version = 1;
    this.forward_url = params.forward_url;
  }
}
